var render = function render(){var _vm=this,_c=_vm._self._c;return _c('add-banks',{attrs:{"prev":_vm.prevRoute}})
}
var staticRenderFns = []

export { render, staticRenderFns }